var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconLive = function SvgIconLive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.446 2.447 1.42 1.418A7.98 7.98 0 0 0 2 10a7.985 7.985 0 0 0 2.866 6.136l-1.419 1.418C1.335 15.721 0 13.016 0 10s1.335-5.72 3.446-7.553zm13.108 0C18.665 4.28 20 6.984 20 10s-1.335 5.72-3.446 7.553l-1.42-1.418A7.98 7.98 0 0 0 18 10a7.984 7.984 0 0 0-2.864-6.134l1.418-1.42zM6.287 5.287l1.43 1.429A3.99 3.99 0 0 0 6 10c0 1.36.679 2.562 1.716 3.284l-1.429 1.43A5.992 5.992 0 0 1 4 10a5.99 5.99 0 0 1 2.287-4.714zm7.427 0A5.993 5.993 0 0 1 16 10a5.99 5.99 0 0 1-2.287 4.714l-1.43-1.43A3.99 3.99 0 0 0 14 10c0-1.36-.678-2.561-1.715-3.284l1.429-1.429zM10 8a2 2 0 1 1 .001 3.999A2 2 0 0 1 10 8z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
};

export default SvgIconLive;